var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/copy-grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.6,9.3 C18.759798,9.3 19.7,10.240202 19.7,11.4 L19.7,17.6 C19.7,18.759798 18.759798,19.7 17.6,19.7 L11.4,19.7 C10.240202,19.7 9.3,18.759798 9.3,17.6 L9.3,11.4 C9.3,10.240202 10.240202,9.3 11.4,9.3 Z M17.6,10.7 L11.4,10.7 C11.0134007,10.7 10.7,11.0134007 10.7,11.4 L10.7,17.6 C10.7,17.9865993 11.0134007,18.3 11.4,18.3 L17.6,18.3 C17.9865993,18.3 18.3,17.9865993 18.3,17.6 L18.3,11.4 C18.3,11.0134007 17.9865993,10.7 17.6,10.7 Z M12.6153846,4.3 C13.7166293,4.3 14.6184302,5.15392065 14.6947659,6.23574067 L14.7,6.38461538 L14.7,7.07692308 C14.7,7.4635224 14.3865993,7.77692308 14,7.77692308 C13.6456173,7.77692308 13.3527418,7.51357945 13.3063902,7.17190893 L13.3,7.07692308 L13.3,6.38461538 C13.3,6.04088572 13.0466837,5.75632124 12.7165521,5.70742299 L12.6153846,5.7 L6.38461538,5.7 C6.04088572,5.7 5.75632124,5.95331632 5.70742299,6.28344794 L5.7,6.38461538 L5.7,12.6153846 C5.7,12.9591143 5.95331632,13.2436788 6.28344794,13.292577 L6.38461538,13.3 L7.07692308,13.3 C7.4635224,13.3 7.77692308,13.6134007 7.77692308,14 C7.77692308,14.3543827 7.51357945,14.6472582 7.17190893,14.6936098 L7.07692308,14.7 L6.38461538,14.7 C5.28337068,14.7 4.38156982,13.8460794 4.3052341,12.7642593 L4.3,12.6153846 L4.3,6.38461538 C4.3,5.28337068 5.15392065,4.38156982 6.23574067,4.3052341 L6.38461538,4.3 L12.6153846,4.3 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/copy-grey",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/medium-grey",
    mask: "url(#mask-2)",
    fill: "#949393"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyGrey);
export default __webpack_public_path__ + "static/media/copy-grey.21f1c0b4a7a34d753d058a6725a699d2.svg";
export { ForwardRef as ReactComponent };